const buildEditableAttribute = editableProperty => {
  return editableProperty ? ` data-property="${editableProperty}"` : ''
}

export default buildEditableAttribute
